module.exports = __webpack_public_path__ + "static/media/0001.c01c7686.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48103/Decors_colored/C06_black/0001.png
// module id = 886
// module chunks = 0